// `video.splice`: an insert laid over a window of a video, its sound copied (spec G14-grwm), the
// worker's own ffmpeg. Live has no such job; a template's run starts it.
import { VideoSpliceQuote, VideoSpliceRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.splice"> = {
  type: "video.splice",
  label: "Splice",
  source: "form",
  pair: "video.splice",
  fields: () => ({}),
  request: VideoSpliceRequest,
  quote: VideoSpliceQuote,
};
